exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#recipe-card[data-v-eff7ea12]{padding:0;display:flex;flex-direction:column;justify-content:center;align-items:center;border-radius:1rem;width:23.5%;min-height:40vh;max-height:40vh;border:.15rem solid #000;cursor:pointer;background-color:#e0e5b6}h2[data-v-eff7ea12]{margin:0;text-align:center}img[data-v-eff7ea12]{margin:0 0 1rem;border-radius:1.2rem;border:.15rem solid #000}@media only screen and (max-width:768px){#recipe-card[data-v-eff7ea12]{width:100%}img[data-v-eff7ea12]{width:80%;height:80%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eff7ea12","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RecipeCard.vue
// module id = 74
// module chunks = 0